import LoginActionHandlerBase from './action_handler_base';

export default class PlayForFunActionHandler extends  LoginActionHandlerBase {
    static CLASS = 'PlayForFunActionHandler';

    actionName() {
        return 'onplayforfun';
    }

    execute() {
        this.serviceFactory.webLoginService().closeLoginForm();
    }
}